import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderBy } from '../../redux/helpers/index';

import LayoutGallery from '../layout-gallery/LayoutGallery';

class LayoutContainer extends Component {
  getOrderedLayouts(layouts) {
    return orderBy(layouts, 'order', 'ASC');
  }

  render() {
    const {
      placeholders,
      pages,
      layouts,
      lang,
    } = this.props;

    const orderedLayouts = this.getOrderedLayouts(layouts);

    return (
      <LayoutGallery
        placeholders={placeholders}
        pages={pages}
        layouts={orderedLayouts}
        lang={lang}
      />
    );
  }
}

export default connect(state => ({
  layouts: state.entities.layouts.byId,
  placeholders: state.entities.placeholders.allIds,
  pages: state.entities.pages,
}))(LayoutContainer);



// WEBPACK FOOTER //
// ./src/components/layout-container/LayoutContainer.jsx